import React from "react";
import { useSelector } from "react-redux";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { storage } from "../../firebase";

// Helper function to resize an image
const resizeImage = (file, width, height) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        const reader = new FileReader();

        reader.onload = (e) => {
            img.src = e.target.result;
        };

        img.onload = () => {
            const canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, width, height);

            canvas.toBlob((blob) => {
                if (blob) {
                    const resizedFile = new File([blob], `${width}x${height}_${file.name}`, { type: file.type });
                    resolve(resizedFile);
                } else {
                    reject(new Error("Canvas toBlob failed"));
                }
            }, file.type);
        };

        img.onerror = (err) => reject(err);
        reader.readAsDataURL(file);
    });
};

const FirebaseImageStoreResizer = ({ selectedFile, functionCall }) => {
    const userData = useSelector((state) => state.userData.userData);

    const uploadToFirebase = (file, path) => {
        return new Promise((resolve, reject) => {
            const storageRef = ref(storage, path);
            const uploadTask = uploadBytesResumable(storageRef, file);

            uploadTask.on(
                "state_changed",
                (snapshot) => {
                    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    console.log(`Upload is ${progress}% done for ${path}`);
                },
                reject,
                async () => {
                    const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                    resolve({ downloadURL, path });
                }
            );
        });
    };

    const saveAvatar = async () => {
        try {
            const basePath = `images/${userData.creator_auth}/${Date.now()}`;

            // Upload original
            const originalPath = `${basePath}_original_${selectedFile.name}`;
            const originalUpload = await uploadToFirebase(selectedFile, originalPath);

            // Create and upload resized images
            const sizes = [
                { name: "thumbnail100x100", width: 100, height: 100 },
                { name: "thumbnail300x300", width: 300, height: 300 },
                { name: "thumbnail300x150", width: 300, height: 150 }
            ];

            const resizedUploads = await Promise.all(
                sizes.map(async ({ name, width, height }) => {
                    const resizedFile = await resizeImage(selectedFile, width, height);
                    const path = `${basePath}_${name}_${selectedFile.name}`;
                    return await uploadToFirebase(resizedFile, path);
                })
            );

            functionCall({
                original: originalUpload,
                thumbnails: resizedUploads
            });
        } catch (error) {
            console.error("Upload failed:", error);
        }
    };

    return { saveAvatar };
};

export default FirebaseImageStoreResizer;
